/**
 * @desc 回传入库单信息
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.RejectBillCallBackRpcDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/asMasterialReject/rebacRejectkBill`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
